import { render, staticRenderFns } from "./CPageStoreIndexStandard.vue?vue&type=template&id=35f1c60a&"
import script from "./CPageStoreIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageStoreIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports